(function () {
  'use strict';

  var triggerSelector = '.storecrm-restock, .storecrm-line-restock';
  var containerSelector =
    '.storecrm-button[data-type="restock-button"][data-variant-id], ' +
    '.storecrm-button[data-type="line-restock-button"][data-variant-id]';
  var favoriteContainerSelector =
    '.option-select .storecrm-button[data-type="wishlist-button"][data-variant-id]';

  function isVariantId(value) {
    return Boolean(value && /^\d+$/.test(value));
  }

  function useVariantForNextEmailPopup(variantId, productId) {
    var storecrm = window.storecrm;
    var popupManager = storecrm && storecrm.popupManager;
    if (!popupManager || typeof popupManager.show !== 'function') {
      return;
    }

    var original = popupManager.show;
    var restoreTimer;

    function restore() {
      window.clearTimeout(restoreTimer);
      if (popupManager.show === showRowVariant) {
        popupManager.show = original;
      }
    }

    function showRowVariant(buttonSettings, variants, popupProductId, options) {
      if (String(popupProductId) !== productId) {
        return original.apply(popupManager, arguments);
      }

      var nextOptions = {};
      if (options) {
        for (var key in options) {
          if (Object.prototype.hasOwnProperty.call(options, key)) {
            nextOptions[key] = options[key];
          }
        }
      }
      nextOptions.variantId = variantId;

      restore();
      return original.call(
        popupManager,
        buttonSettings,
        variants,
        popupProductId,
        nextOptions
      );
    }

    popupManager.show = showRowVariant;
    restoreTimer = window.setTimeout(restore, 10000);
  }

  function useVariantForNextRestockFlow(variantId) {
    var storecrm = window.storecrm;
    if (!storecrm || typeof storecrm.getCurrentRestockVariantId !== 'function') {
      return;
    }

    var original = storecrm.getCurrentRestockVariantId;
    var restoreTimer;
    var used = false;

    function restore() {
      window.clearTimeout(restoreTimer);
      if (storecrm.getCurrentRestockVariantId === getRowVariantId) {
        storecrm.getCurrentRestockVariantId = original;
      }
    }

    function getRowVariantId() {
      /*
       * showRestock/showLineRestockPopupはログイン確認後にこのメソッドを呼ぶ。
       * 最初に使われた同一タスク中は行のvariantを返し、処理が必要な値を
       * 取り終えた直後のmicrotaskでStoreCRM本来の実装へ戻す。
       */
      if (!used) {
        used = true;
        window.queueMicrotask(restore);
      }
      return variantId;
    }

    storecrm.getCurrentRestockVariantId = getRowVariantId;
    restoreTimer = window.setTimeout(restore, 10000);
  }

  /*
   * StoreCRMはクリック元のdata-variant-idを再入荷処理へ渡さないため、
   * キャプチャフェーズで次の再入荷処理だけが押下行のvariantを返すようにする。
   * 通常のメール再入荷モーダルにはpopupManager.showのoptionsとして
   * 押下行のvariantを直接渡す。
   * URLは変更しないため、同じページのお気に入り再描画には影響しない。
   */
  document.addEventListener(
    'click',
    function (event) {
      var eventTarget = event.target;
      if (!(eventTarget instanceof Element)) return;

      var trigger = eventTarget.closest(triggerSelector);
      if (trigger) {
        var container = trigger.closest(containerSelector);
        if (!container) return;

        var variantId = container.getAttribute('data-variant-id');
        if (!isVariantId(variantId)) return;

        if (container.getAttribute('data-type') === 'restock-button') {
          var productId = container.getAttribute('data-product-id');
          if (productId) {
            useVariantForNextEmailPopup(variantId, String(productId));
          }
        }
        useVariantForNextRestockFlow(variantId);
        return;
      }

      /*
       * 行ごとのお気に入りは、StoreCRMが生成したbuttonにもラッパーの
       * data-variant-idを渡す。URLにvariantがある場合でも押下行を優先する。
       */
      var favoriteButton = eventTarget.closest('button');
      if (!favoriteButton) return;

      var favoriteContainer = favoriteButton.closest(favoriteContainerSelector);
      if (!favoriteContainer) return;

      var favoriteVariantId = favoriteContainer.getAttribute('data-variant-id');
      if (!isVariantId(favoriteVariantId)) return;

      favoriteButton.setAttribute('data-variant-id', favoriteVariantId);
    },
    true
  );
})();
